// Ported from https://www.npmjs.com/package/vue-clickaway2, updated with directive
// lifecycle hooks for Vue 3.
//
// Copied from acv-shared-vuejs's src/directives/clickaway.js (not re-exported from that
// package's public barrel) rather than adding a cross-repo coordination dependency for
// this one directive. Behavior is unchanged from the source; only rewritten to satisfy
// this repo's ESLint config (var/function-expression era syntax -> const/arrow).

const HANDLER = '_vue_clickaway_handler';

function unmounted(el, binding) {
  if (binding.arg) {
    document.documentElement.removeEventListener(binding.arg, el[HANDLER], false);
  } else {
    document.documentElement.removeEventListener('click', el[HANDLER], false);
  }

  // eslint-disable-next-line no-param-reassign
  delete el[HANDLER];
}

function beforeMount(el, binding) {
  unmounted(el, binding);

  const { instance: vm } = binding;

  const callback = binding.value;
  if (typeof callback !== 'function') {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`v-${binding.name}="${binding.expression}" expects a function value, got ${callback}`);
    }
    return;
  }

  // @NOTE: Vue binds directives in microtasks, while UI events are dispatched
  //        in macrotasks. This causes the listener to be set up before
  //        the "origin" click event (the event that lead to the binding of
  //        the directive) arrives at the document root. To work around that,
  //        we ignore events until the end of the "initial" macrotask.
  // @REFERENCE: https://jakearchibald.com/2015/tasks-microtasks-queues-and-schedules/
  // @REFERENCE: https://github.com/simplesmiler/vue-clickaway/issues/8
  let initialMacrotaskEnded = false;
  setTimeout(() => {
    initialMacrotaskEnded = true;
  }, 0);

  const handler = (ev) => {
    // @NOTE: this test used to be just `el.contains`, but working with path is better,
    //        because it tests whether the element was there at the time of
    //        the click, not whether it is there now, that the event has arrived
    //        to the top.
    // @NOTE: `.path` is non-standard, the standard way is `.composedPath()`
    const path = ev.path || (ev.composedPath ? ev.composedPath() : undefined);
    if (initialMacrotaskEnded && (path ? !path.includes(el) : !el.contains(ev.target))) {
      callback.call(vm, ev);
    }
  };
  // eslint-disable-next-line no-param-reassign
  el[HANDLER] = handler;

  if (binding.arg) {
    document.documentElement.addEventListener(binding.arg, handler, false);
  } else {
    document.documentElement.addEventListener('click', handler, false);
  }
}

const directive = {
  beforeMount,
  updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    beforeMount(el, binding);
  },
  unmounted,
};

const mixin = {
  directives: { onClickaway: directive },
};

export { directive, mixin };
